import { BybBackground } from "@Components/game/common";
import PositionSelectorDialog from "@Components/game/common/position-selector/position-selector-dialog";
import SessionResultsLoadingOverlay from "@Components/game/common/session-results-loading-overlay";
import { MATCHPLAY_POSITION_SELECTOR_CONFIG } from "@Constants/game/position-config";
import { GameModeContainer } from "@Components/game/game-mode";
import { MatchPlayOverview, MatchPlaySettings } from "@Components/game/match-play";
import ContainerWrapper from "@Components/generic/container-wrapper";
import { MatchPlayProvider, useMatchPlayContext } from "@Context/game/match-play/match-play-context";
import StorageKeys from "@Enums/StorageKeys";
import { Container, Stack, useTheme } from "@mui/material";

const PageId = "MATCH-PLAY";
const MATCH_PLAY_BACKGROUND_URL = "https://challenge-thumbs.b-cdn.net/byb-mode-posters/img-matchplay-full.jpg";

const MatchPlayContent = () => {
  const theme = useTheme();
  const { closePositionSelect, handlePositionsSelected, initialSelectedPositions, isCompletingSession, isPositionSelectOpen } = useMatchPlayContext();

  return (
    <ContainerWrapper id={PageId} fullHeight sx={{ position: "relative", "& .MuiContainer-root": { position: "relative", zIndex: 1 } }}>
      <BybBackground imageUrl={MATCH_PLAY_BACKGROUND_URL} />
      <Container maxWidth="xl">
        <Stack width="100%" paddingTop={theme.spacing(15)}>
          <GameModeContainer>
            <MatchPlayOverview />
            <MatchPlaySettings />
          </GameModeContainer>
        </Stack>

        <PositionSelectorDialog
          isOpen={isPositionSelectOpen}
          onClose={closePositionSelect}
          onPositionsSelected={handlePositionsSelected}
          initialPositions={initialSelectedPositions}
          showSectionChips={false}
          selectorConfig={MATCHPLAY_POSITION_SELECTOR_CONFIG}
          storageKey={StorageKeys.MATCHPLAY_SELECTED_POSITIONS}
        />
      </Container>

      <SessionResultsLoadingOverlay open={isCompletingSession} />
    </ContainerWrapper>
  );
};

const MatchPlay = () => (
  <MatchPlayProvider>
    <MatchPlayContent />
  </MatchPlayProvider>
);

export default MatchPlay;
